// extracted by mini-css-extract-plugin
module.exports = {"phoneNumberDescription":"PhoneNumber_phoneNumberDescription__mHqy5"};